import type { KeyboardShortcut } from 'components/editor/hooks/useKeyboardShortcuts';

interface UseSignatureKeyboardShortcutsProps {
  isSignatureSelected: boolean;
  onSignatureKeyboardMove: (deltaX: number, deltaY: number) => void;
  onSignatureDelete: () => void;
}

export const useSignatureKeyboardShortcuts = ({
  isSignatureSelected,
  onSignatureKeyboardMove,
  onSignatureDelete,
}: UseSignatureKeyboardShortcutsProps): KeyboardShortcut[] => {
  const keyboardShortcuts: KeyboardShortcut[] = [
    {
      key: 'Delete',
      callback: () => {
        onSignatureDelete();
      },
      isEnable: isSignatureSelected,
    },
    {
      key: 'Backspace',
      callback: () => {
        onSignatureDelete();
      },
      isEnable: isSignatureSelected,
    },
    {
      key: 'ArrowUp',
      shift: true,
      callback: () => {
        onSignatureKeyboardMove(0, -10);
      },
      isEnable: isSignatureSelected,
    },
    {
      key: 'ArrowDown',
      shift: true,
      callback: () => {
        onSignatureKeyboardMove(0, 10);
      },
      isEnable: isSignatureSelected,
    },
    {
      key: 'ArrowLeft',
      shift: true,
      callback: () => {
        onSignatureKeyboardMove(-10, 0);
      },
      isEnable: isSignatureSelected,
    },
    {
      key: 'ArrowRight',
      shift: true,
      callback: () => {
        onSignatureKeyboardMove(10, 0);
      },
      isEnable: isSignatureSelected,
    },
    {
      key: 'ArrowUp',
      callback: () => {
        onSignatureKeyboardMove(0, -1);
      },
      isEnable: isSignatureSelected,
    },
    {
      key: 'ArrowDown',
      callback: () => {
        onSignatureKeyboardMove(0, 1);
      },
      isEnable: isSignatureSelected,
    },
    {
      key: 'ArrowLeft',
      callback: () => {
        onSignatureKeyboardMove(-1, 0);
      },
      isEnable: isSignatureSelected,
    },
    {
      key: 'ArrowRight',
      callback: () => {
        onSignatureKeyboardMove(1, 0);
      },
      isEnable: isSignatureSelected,
    },
  ];

  return keyboardShortcuts;
};
